import { PageProps } from 'gatsby';
import CardListPageTemplate from '../components/CardListPageTemplate';

const CategoryPage = ({ pageContext }: PageProps<object, { categorySlug: string }>) => {
  const categorySlug = pageContext.categorySlug;
  return <CardListPageTemplate selectedCategorySlug={categorySlug} />;
};

export default CategoryPage;